import Image from '../Image/Image';
import Card from './Card';
import CardContent from './CardContent';

Card.Image = Image;
Card.Content = CardContent;

export default Card;
